var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrievanceMonBottomLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 4,
    viewBox: "0 0 139 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.556624 2.00001L2 3.44339L3.44338 2.00001L2 0.556636L0.556624 2.00001ZM138.443 2.00001L137 0.556636L135.557 2.00001L137 3.44339L138.443 2.00001ZM2 2.25001L137 2.25001L137 1.75001L2 1.75001L2 2.25001Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrievanceMonBottomLine);
export default __webpack_public_path__ + "static/media/grievance-mon-bottom-line.26575c776f6bcaca52cbc232283dcefa.svg";
export { ForwardRef as ReactComponent };